export const CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const CHEST_AND_ABDOMEN_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceChestAndAbdomen: CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES,
    claviclesChestAndAbdomen: CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES,
    nipplesBreastBudsChestAndAbdomen: CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES,
    palpationChestAndAbdomen: CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES,
    umbilicusChestAndAbdomen: CHEST_AND_ABDOMEN_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsChestAndAbdomenSections =
  keyof typeof CHEST_AND_ABDOMEN_FORM_INITIAL_VALUES.sections;
